import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedal = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 11C11.2614 11 13.5 8.76142 13.5 6C13.5 3.23858 11.2614 1 8.5 1C5.73858 1 3.5 3.23858 3.5 6C3.5 8.76142 5.73858 11 8.5 11Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 9C10.1569 9 11.5 7.65685 11.5 6C11.5 4.34315 10.1569 3 8.5 3C6.84315 3 5.5 4.34315 5.5 6C5.5 7.65685 6.84315 9 8.5 9Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 10V15L8.5 13.5L5.5 15V10",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMedal;
